import { render, staticRenderFns } from "./UserTaxDetails.vue?vue&type=template&id=22ca0ddc&"
import script from "./UserTaxDetails.vue?vue&type=script&lang=ts&"
export * from "./UserTaxDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports